import React from "react";
import _ from "lodash";
import PopupWrapper from "components/common/PopupWrapper";
import { formatMoneyWithCurrency } from "components/playground/home-dashboard-v1/ReportsHelper";
import AdvertiserAndBrandsSelector from "./AdvertiserAndBrandsSelector";
import SensitiveCategoriesSelector from "./SensitiveCategoriesSelector";
import DemandSourceView from "./DemandSourceView";
import { GAM_CREATIVE_TYPES_NAME, SKIPPABILITY_TYPE } from "./Constants";

const PRICE_TYPE_NAME = {
  0: "Floor",
  1: "Target CPM",
  // LGO: 2, // not an option for brand price settings
};

class UprPriceSectionPopover extends React.PureComponent {
  render() {
    const {
      demandSource = {},
      targetingSection = {},
      triggerElement,
      currency,
      networkId,
      onOpen,
      onClose,
      place = "bottom",
    } = this.props;
    // inventory, device category, os, country...
    const { brandedPriceSettings } = targetingSection;

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        onOpen={onOpen}
        onClose={onClose}
        popupElement={
          <div
            className="shadow border overflow-y-auto p-4"
            style={{ width: "600px", maxHeight: "600px" }}
          >
            <div>
              <div className="mt-2 font-semibold text-gray-900">
                Branded Price Settings (
                {brandedPriceSettings ? brandedPriceSettings.length : 0})
              </div>
              <div>
                {brandedPriceSettings ? (
                  <div className="flex flex-col gap-3">
                    {brandedPriceSettings.map((item, index) => {
                      let numOfAdvertisersAndBrands = 0;
                      if (item.targeting.advertisersAndBrands) {
                        numOfAdvertisersAndBrands = _.filter(
                          item.targeting.advertisersAndBrands,
                          (a) => {
                            return a.advertiserId !== "0";
                          }
                        ).length;
                      }
                      return (
                        <div
                          className="border-t-2 border-gray-600 pt-3"
                          key={index}
                        >
                          <div
                            key={index}
                            className="border divide-y flex flex-col p-2"
                          >
                            {item.branded && (
                              <div className="pb-1">
                                <div className="text-sm font-semibold leading-tight text-gray-800">
                                  Branded
                                </div>
                                <div
                                  className={
                                    item.branded === "BLOCKED" && "text-red-600"
                                  }
                                >
                                  {item.branded}
                                </div>
                              </div>
                            )}
                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Demand Sources
                              </div>
                              <DemandSourceView
                                demandSource={demandSource}
                                data={item.targeting.demandSources}
                              ></DemandSourceView>
                            </div>

                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Advertisers and Brands{" "}
                                <span>({numOfAdvertisersAndBrands})</span>
                              </div>
                              <div className="leading-tight">
                                {item.targeting.advertisersAndBrands ? (
                                  <div>
                                    <AdvertiserAndBrandsSelector
                                      networkId={networkId}
                                      // targetingType="advertisersAndBrands"
                                      targeting={
                                        item.targeting["advertisersAndBrands"]
                                      }
                                      isDisabled={true}
                                      // handleTargetingChanged={this.handleAdvertiserAndBrandsChanged}
                                    ></AdvertiserAndBrandsSelector>
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>

                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Sizes
                              </div>
                              <div>
                                {item.targeting.sizes ? (
                                  <SegmentTarget
                                    targetType="SIZES"
                                    targetData={item.targeting.sizes}
                                  ></SegmentTarget>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>

                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Sensitive Categories{" "}
                                {(item.targeting.sensitiveCategories || [])
                                  .length > 0
                                  ? `(${item.targeting.sensitiveCategories.length})`
                                  : ""}
                              </div>
                              <div>
                                {item.targeting.sensitiveCategories ? (
                                  <SensitiveCategoriesSelector
                                    isReadonly={true}
                                    networkId={networkId}
                                    targeting={
                                      item.targeting.sensitiveCategories
                                    }
                                  ></SensitiveCategoriesSelector>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>

                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Creative Format
                              </div>
                              <div className="text-sm">
                                {item.targeting.creativeTypes ? (
                                  <span>
                                    {
                                      GAM_CREATIVE_TYPES_NAME[
                                        item.targeting.creativeTypes
                                      ]
                                    }
                                  </span>
                                ) : (
                                  "Any Creative Type"
                                )}
                              </div>
                            </div>

                            <div className="pb-1">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Video Option
                              </div>
                              <div className="text-xs">
                                {item.targeting.videoOption ? (
                                  <>
                                    <label className="block text-gray-800">
                                      Minimum Duration (seconds)
                                    </label>
                                    <span className="mb-1">
                                      {item.targeting.videoOption.minDuration}{" "}
                                    </span>

                                    <label className="block text-gray-800">
                                      Video Skippability Type
                                    </label>
                                    <span className="">
                                      {
                                        SKIPPABILITY_TYPE[
                                          item.targeting.videoOption.type
                                        ]
                                      }
                                    </span>
                                  </>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>

                            <div className="">
                              <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                Price
                              </div>
                              <div className="text-sm">
                                {PRICE_TYPE_NAME[item.priceType]}{" "}
                                {formatMoneyWithCurrency({
                                  currency: item.currency || currency,
                                  value: item.price,
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        }
      ></PopupWrapper>
    );
  }
}

class SegmentTarget extends React.PureComponent {
  render() {
    const { targetData, targetType } = this.props;

    const isInclude = targetData.includes;
    let op = isInclude ? "Includes" : "Excludes";
    let targets = isInclude ? targetData.includes : targetData.excludes;

    targets = _.map(targets, (t) => {
      return t;
    });

    return (
      <div className="text-sm">
        {targetData && (
          <div>
            <div
              className={`${
                isInclude ? "text-green-500" : "text-red-500"
              } font-medium`}
            >
              {op} ({targets.length})
            </div>
            <div className="flex flex-wrap gap-1">
              {targets.map((value, i) => {
                return (
                  <div key={i} className="bg-gray-200 px-1">
                    {value}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UprPriceSectionPopover;
